module.exports = __webpack_public_path__ + "img/PatriotLogo.a393862b.png";